// https://l2.io/ip.js?var=visitor_ip
// https://apidev.accuweather.com/locations/v1/cities/ipaddress?q=98.228.171.62&apikey=8e7965ebd7f34b88a4a393918d246f1b

const WeatherApp = () => import(/* webpackChunkName: "WeatherApp" */ './WeatherApp');

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            // here I check that click was outside the el and his children
            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});

function init_vue_weather_app(selector)
{
    window.accu_weather_app = new Vue({
        name: 'accu-weather-app',
        el: selector,
        render: h => h(WeatherApp),
    });
}

function should_load_app(selector){

    if( window.innerWidth >= 728 && window.$(selector) && window.$(selector).inViewport(30) ){
        return true;
    }

    return false;
}

function lazy_init_weather_app(selector)
{
    var lazy_init_callback = function(){
        if( should_load_app(selector) ){
            init_vue_weather_app(selector);
            $(window).off("scroll rezise", lazy_init_callback);
        }
    }

    $(window).on('scroll rezise', lazy_init_callback).scroll().resize();
}

function init_weather_look_up(){

    var selector = '.weather-app';

    if( should_load_app(selector) ){
        init_vue_weather_app(selector);
    }else{
        lazy_init_weather_app(selector);
    }

}

$(document).ready(function(){
    init_weather_look_up();
});